import { render, staticRenderFns } from "./editApplyRoomDiscountRecord.vue?vue&type=template&id=07d2dcd8&scoped=true"
import script from "./editApplyRoomDiscountRecord.vue?vue&type=script&lang=js"
export * from "./editApplyRoomDiscountRecord.vue?vue&type=script&lang=js"
import style0 from "./editApplyRoomDiscountRecord.vue?vue&type=style&index=0&id=07d2dcd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2dcd8",
  null
  
)

export default component.exports